<template>
  <ul>
    <li v-for="file in fileTypes" :key="file" class="modal-retrieve__checkbox-wrapper">
      <div class="modal-retrieve__checkbox checkbox-holder block">
        <input
          v-model="selectedFileTypes"
          :id="idPrefix + file"
          type="checkbox"
          :name="idPrefix + file"
          :value="file" />
        <label :for="idPrefix + file">{{ explicitFileType(file) }}</label>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import { 
  RETRIEVE_FILES_FORMATS, 
  RETRIEVE_FILES_FORMATS_MW, 
  RETRIEVE_FILES_FORMATS_EC225 
} from '../../utils/constants/retrieveFilesFormats.js'

export default {
  name: 'ModalRetrieveFileTypes',
  props: {
    heliType: {
      type: String
    },
    isLogsMode:
    {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selectedFileTypes(newVal) {
      this.$emit('event-types-valid', newVal.length > 0);
    }
  },
  computed: {
    // Generates a unique prefix for HTML attributes to prevent DOM collisions
    idPrefix() {
      return this.isLogsMode ? 'logs_file_' : 'sessions_file_';
    },
  },
  data () {
    let fileTypes = []

    if (this.isLogsMode) {
      fileTypes = ["LOGS", "SYSTEM", "SECURITY"];
    }
    else {
      fileTypes = RETRIEVE_FILES_FORMATS

      if (this.heliType == 'AS350_B3' || this.heliType == 'EC130_T2' || this.heliType  == "EC135_T4") {
        fileTypes = RETRIEVE_FILES_FORMATS_MW
      }
      else if (this.heliType == 'EC225_LP') {
        fileTypes = RETRIEVE_FILES_FORMATS_EC225
      }
    }
    return {
      fileTypes: fileTypes,
      selectedFileTypes: fileTypes.slice(0) // Initialize all checkboxes as selected
    }
  },
  methods: {
    getTypesData () {
      return this.selectedFileTypes
    },
    explicitFileType (type) {
      if (this.isLogsMode) {
        return type
      } else {
        const typeMap = {
          'VMS_UMS': 'USAGE',
          'MFDAU': 'HUMS',
          'healthRawData': 'HEALTH RAW DATA',
          'DMAU': 'HEALTH'
        }
        return typeMap[type] || type;
      }
    }
  }
}
</script>
